import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import Carousel from 'react-bootstrap/Carousel';
import BannerSection from "../../../components/ui/BannerSection";


const Eventos = [
  {
    id: 1,
    images: [
      require('../../../assets/ANU_02.jpg'),
      require('../../../assets/ANU_02_1.jpg'),
      require('../../../assets/ANU_02_2.jpg'), 
    ],
    title: '3ª Cerimônia de Outorga de Diplomas',
    subtitle: 'Conquista de Hoje, Compromisso com o Amanhã ',
    category: 'Outorga',
    data: ' 16-Setembro-2023  | 09H - 12H',
    content: 'Na Cerimônia de Outorga de Diplomas doInstituto Superior Politécnico Atlântida, os formandos da turma de 2024 se reuniram ansiosos no auditório. Com discursos inspiradores, eles receberam seus diplomas. \n\n',
    video: null
  },
  {
    id: 2,
    images: [
      require('../../../assets/ANU_02_4.jpg'),
    ],
    title: 'Baptismo dos Caloiros',
    category: 'Comeroração',
    subtitle: 'Uma Tradição de Boas-Vindas e Integração',
    content: 'No tradicional evento do Baptismo dos Caloiros, os novos estudantes se reuniram em um clima de excitação e nervosismo. Eles participaram de rituais simbólicos e receberam as boas-vindas da comunidade acadêmica. Após o evento, os caloiros se integraram ainda mais à vida universitária, celebrando o início de sua jornada acadêmica com os veteranos em uma atmosfera de camaradagem e espírito de equipe.',
    video: null
  },
  {
    id: 3,
    images: [
      require('../../../assets/ANU_02_10.jpg'),
    ],
    title: 'Juventude Investigadora: Construindo o Futuro da Ciência',
    subtitle: 'Despertar Científico nas Novas Gerações: Da Curiosidade à Inovação',
    category: 'Investigação',
    content: 'A ciência avança quando há curiosidade, coragem para questionar e dedicação à busca por respostas. A juventude investigadora representa exatamente isso: mentes inquietas, cheias de ideias, energia e vontade de transformar o mundo.',
    content2: 'Neste encontro, refletiremos sobre o papel fundamental que os jovens estudantes e investigadores têm desempenhado no progresso científico e tecnológico. O subtema, "Despertar Científico nas Novas Gerações: Da Curiosidade à Inovação", destaca o percurso natural que começa com o fascínio pelo desconhecido e pode culminar em descobertas impactantes.',
    video: null
  },
  {
    id: 4,
    images: [
      require('../../../assets/ANU_02_11.jpg'),
    ],
    title: 'Juventude, Conhecimento e Segurança: Um Compromisso Social',
    subtitle: 'Despertar Científico nas Novas Gerações: Da Curiosidade à Inovação',
    category: 'Comemoração',
    content: 'O evento destacou a importância da colaboração entre estudantes, docentes e agentes policiais, promovendo o diálogo, o respeito mútuo e o papel transformador da educação na construção de uma sociedade mais segura, informada e solidária.',
    content2: 'Durante a atividade, foram reconhecidos com certificados de mérito os agentes policiais que, com dedicação e profissionalismo, contribuíram para o sucesso do encontro. Esse reconhecimento simboliza o apreço da comunidade académica pela atuação exemplar destes profissionais, que atuam não apenas como guardiões da ordem pública, mas também como parceiros na promoção do conhecimento e da cidadania.',
    video: null
  },
  {
    id: 5,
    images: [
      require('../../../assets/ANU_02_6.jpg'),
    ],
    title: 'Entre Letras e Ideias: Construindo Conhecimento Através da Leitura',
    subtitle: 'Literatura e Ensino no Espaço Acadêmico',
    category: 'Evento Cultural',
    content: 'Mais do que um encontro com livros, o evento foi um convite à reflexão, à descoberta e ao pensamento crítico, proporcionando à comunidade académica e ao público em geral uma experiência rica em cultura e aprendizagem. Em cada página lida, em cada conversa literária, em cada partilha de ideias, reforçou-se o papel do livro como instrumento de construção do conhecimento e da liberdade de pensamento.',
    content2: 'A feira contou com exposições de obras literárias e científicas, sessões de leitura, apresentação de autores locais, oficinas temáticas, debates e momentos culturais que envolveram professores, estudantes, escritores e leitores de diferentes gerações.Este evento reforçou a ideia de que, entre letras e ideias, se constrói uma sociedade mais consciente, criativa e preparada para os desafios do mundo.',
    video: null
  },
  {
    id: 6,
    images: [
      require('../../../assets/ANU_02_5.jpg'),
    ],
    title: 'Semana da Investigação e Extensão Universitária',
    subtitle: 'Extensão Universitária como Ponte entre Conhecimento e Desenvolvimento',
    category: 'Investigação Científica',
    content: 'A Semana da Investigação e Extensão Universitária decorreu com grande êxito no Instituto Superior, reunindo estudantes, docentes, convidados e membros da comunidade em torno de uma programação diversificada e enriquecedora. Durante o evento, foram realizadas palestras, oficinas, apresentações de trabalhos científicos e atividades de extensão que destacaram o papel transformador do conhecimento acadêmico na sociedade.',
    content2: 'Com o objetivo de incentivar a produção científica, a inovação e o compromisso social, a Semana permitiu que os estudantes apresentassem os resultados das suas investigações e partilhassem experiências de projetos desenvolvidos junto às comunidades locais. As atividades abordaram temas interdisciplinares ligados à saúde, educação, tecnologia, meio ambiente, cultura e cidadania.',
    video: null
  },
  {
    id: 7,
    images: [
      require('../../../assets/ANU_02_7.jpg'),
    ],
    title: '5ª Jornada Científica Geral',
    subtitle: 'Extensão Universitária como Ponte entre Conhecimento e Desenvolvimento',
    category: 'Jornada Científica',
    content: 'A 5ª Jornada Científica Geral foi um marco no calendário acadêmico do Instituto Superior, reunindo estudantes, professores, investigadores e membros da comunidade em um espaço de partilha de conhecimento, experiências e inovação.Realizada sob o lema “Inovação e Conhecimento: Caminhos para o Desenvolvimento Sustentável”, a jornada destacou o papel essencial da ciência e da universidade na construção de uma sociedade mais justa, informada e sustentável.',
    content2: 'Durante os dias do evento, os participantes puderam assistir e interagir em palestras temáticas, comunicações orais, exposições de pôsteres científicos, minicursos e mesas-redondas que abordaram temas atuais nas áreas da saúde, educação, tecnologia, meio ambiente e ciências sociais.',
    video: null
  },
  {
    id: 8,
    images: [
      require('../../../assets/ANU_02_8.jpg'),
    ],
    title: 'Semana da Investigação e Extensão Universitária',
    subtitle: 'Extensão Universitária como Ponte entre Conhecimento e Desenvolvimento',
    category: 'Jornada Científica',
    content: 'O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o avanO evento reuniu estudantes, docentes e convidados para uma profunda reflexão.',
    video: null
  },
  {
    id: 9,
    images: [
      require('../../../assets/ANU_04.jpg'),
    ],
    title: 'Jornada Científica Geral',
    subtitle: 'Pesquisas que Transformam',
    category: 'Investigação Científica',
    content: 'A Jornada Científica Geral realizou-se ao longo de três dias no Instituto Superior, reunindo estudantes, docentes, investigadores e membros da comunidade externa. O evento teve como objetivo principal promover a produção e a divulgação do conhecimento científico nas diversas áreas do saber, incentivando a interdisciplinaridade, a inovação e o pensamento crítico.',
    content2: 'Durante a jornada, foram realizadas palestras temáticas, mesas-redondas, apresentações de trabalhos científicos, exposições de pôsteres, bem como oficinas práticas conduzidas por professores e especialistas convidados. O evento contou com a participação ativa dos estudantes, que apresentaram os resultados dos seus projetos de investigação, atividades de extensão e estudos de caso desenvolvidos ao longo do semestre.',
    video: null
  },
  
];

export default function NoticiaDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const Evento = Eventos.find(n => n.id === parseInt(id));

  if (!Evento) {
    return (
      <div style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff"
      }}>
        <div style={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 8px 32px rgba(60,60,120,0.12)",
          padding: "48px 32px",
          textAlign: "center",
          animation: "fadeIn 1s"
        }}>
          {/* Animated page icon */}
          <svg
            width="80"
            height="80"
            viewBox="0 0 48 48"
            fill="none"
            style={{ marginBottom: 24, animation: "pageBounce 1.2s infinite" }}
          >
            <rect x="8" y="8" width="32" height="40" rx="6" fill="#6366f1" />
            <rect x="14" y="16" width="20" height="4" rx="2" fill="#fff" />
            <rect x="14" y="24" width="16" height="4" rx="2" fill="#e0e7ff" />
            <rect x="14" y="32" width="12" height="4" rx="2" fill="#e0e7ff" />
            <rect x="8" y="8" width="32" height="8" rx="4" fill="#0ea5e9" />
            <rect x="12" y="10" width="8" height="4" rx="2" fill="#fff" />
          </svg>
          <h2 style={{ marginBottom: 16, color: "#6366f1" }}>Evento não encontrado</h2>
          <p style={{ marginBottom: 32, color: "#444" }}>
            Ops! O Evento que você procura não existe ou foi removida.<br />
            Volte para a página de evento e explore outras novidades!
          </p>
          <Button
            variant="primary"
            size="lg"
            style={{
              borderRadius: "24px",
              padding: "12px 36px",
              fontWeight: 600,
              fontSize: "1.1rem",
              boxShadow: "0 2px 8px rgba(99,102,241,0.12)"
            }}
            onClick={() => navigate("/noticia")}
          >
            ← Voltar para Eventos
          </Button>
        </div>
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(40px);}
              to { opacity: 1; transform: translateY(0);}
            }
            @keyframes pageBounce {
              0%, 100% { transform: translateY(0);}
              50% { transform: translateY(-12px);}
            }
          `}
        </style>
      </div>
    );
  }
  return (
    <div>
      <BannerSection
          title="Eventos"
          subtitle="Acompanhe os principais eventos do ISPA Atlântida"
          description={`Bem-vindo à seção de eventos do ISPA Atlântida, onde você pode explorar os principais acontecimentos, conferências e atividades que moldam nossa comunidade acadêmica. Fique por dentro das novidades e participe ativamente da vida institucional.`}
          backgroundImage={require('../../../assets/img2.jpg')}
          backgroundId="instituition-Banner"
      />
      {/* Barra de navegação das eventos*/}
      <div style={{ background: "#f5f6fa", padding: "16px 0 8px 0" }}>
        <Container>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ background: "transparent", marginBottom: 0 }}>
              <li className="breadcrumb-item">
                <a href="/" style={{ color: "#00761F", textDecoration: "none" }}>Home</a>
              </li>
              <li className="breadcrumb-item">
                <a href="/evento" style={{ color: "#00761F", textDecoration: "none" }}>Eventos</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page" style={{ color: "#222" }}>
                {Evento.title}
              </li>
            </ol>
          </nav>
        </Container>
      </div>

      <header id='header'>
        <AppHeader />
      </header>
      <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: "40px", marginTop: "40px" }}>
          <div style={{ flex: "1 1 350px", minWidth: 0 }}>
            <h2>{Evento.title}</h2>
            <h5 style={{ marginTop: "20px", color:'#000000' }}><b>{Evento.subtitle}</b></h5>
            <p style={{ marginTop: "10px" }}><b>Categoria:</b> {Evento.category}</p>
            <p style={{ marginTop: "10px" }}>{Evento.content}</p>
            {Evento.content2 && <p style={{ marginTop: "10px" }}>{Evento.content2}</p>}
            <p style={{ marginTop: "10px" }}><b>{Evento.data}</b></p>
            <p style={{ marginTop: "10px" }}>{Evento.preco}</p>
            <p style={{ marginTop: "10px" }}>{Evento.Endereco}</p>
            <p style={{ marginTop: "10px" }}>{Evento.telefone}</p>
            {Evento.video && (
              <p style={{ marginTop: "10px" }}>
                <b>Vídeo:</b> {Evento.video}
              </p>
            )}
          </div>
          <div style={{ flex: "0 1 600px", display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: "24px" }}>
            {Evento.video && (
              <video
                controls
                style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px", marginBottom: Evento.images?.length ? "16px" : 0 }}
                src={Evento.video}
              >
                Seu navegador não suporta a reprodução de vídeo.
              </video>
            )}
            {Evento.images && Evento.images.length > 1 ? (
              <Carousel style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px", overflow: "hidden" }}>
                {Evento.images.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <Image src={img} fluid style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px" }} />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              Evento.images && Evento.images.length === 1 && (
                <Image src={Evento.images[0]} fluid style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px" }} />
              )
            )}
          </div>
        </div>
      </Container>
      <AppLayout />
    </div>
  );
}
